import tailorSaga from './saga';

export default tailorSaga;
